import { Injectable } from '@angular/core';
import { CanActivate, CanLoad } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromApp from '../store';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(
    private oauthService: OAuthService,
    private routerStore: Store<fromApp.RouterState>
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.hasValidToken();
  }
  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this.hasValidToken();
  }
  private hasValidToken(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.oauthService.hasValidAccessToken()) {
      return true;
    }
    this.routerStore.dispatch(new fromApp.Go({ path: [`/`] }));
    return false;
  }
}
